module.exports = __webpack_public_path__ + "img/sleet.dfa6fec2.png";